exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backButton__button___2WkLp {\n  font-size: 14px;\n  text-align: center;\n  border: none;\n  color: #828282;\n  background-color: transparent;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n  .backButton__button___2WkLp .backButton__icon___1zyJJ {\n    font-size: 20px; }\n\n.backButton__button___2WkLp {\n  margin-top: 2px; }\n", ""]);

// exports
exports.locals = {
	"button": "backButton__button___2WkLp",
	"icon": "backButton__icon___1zyJJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdFormPage/StepHeader/BackButton/backButton.scss
// module id = 4727
// module chunks = 6